// Action Identifier enum
export const ActionTypes: {
  [key: string]: number;
  Idle: number;
  Contract: number;
  Operation: number;
  BlackOp: number;
  BlackOperation: number;
  Training: number;
  Recruitment: number;
  FieldAnalysis: number;
  "Field Analysis": number;
  Diplomacy: number;
  "Hyperbolic Regeneration Chamber": number;
  "Incite Violence": number;
} = {
  Idle: 1,
  Contract: 2,
  Operation: 3,
  BlackOp: 4,
  BlackOperation: 4,
  Training: 5,
  Recruitment: 6,
  FieldAnalysis: 7,
  "Field Analysis": 7,
  Diplomacy: 8,
  "Hyperbolic Regeneration Chamber": 9,
  "Incite Violence": 10,
};
